import React, { Component } from 'react'
import { Select } from 'hljd'
import SearchBar from '@common/SearchBar'
import { observer } from 'mobx-react'
import style from './index.module.less'

const Option = Select.Option
const Item = SearchBar.Item

@observer
export default class extends Component {
  render() {
    const { store } = this.props
    return (
      <div className={style.searchWrap}>
        <SearchBar store={store} showReset={false} showSearch={false}>
          <Item name="mealType" initialValue={undefined}>
            <Select style={{ width: 100 }} placeholder="类型">
              <Option value={'1'}>样片</Option>
              <Option value={'2'}>客照</Option>
            </Select>
          </Item>
        </SearchBar>
      </div>
    )
  }
}
